import { constant } from './constants'
import { transform, isEqual, isObject, cloneDeep } from 'lodash'
import { IForm, IGoal, IInitialCampaignDetail, IMessage, IPushCampaignDetail, IQuestion, IAnswer } from './types'
import { randomString } from './helpers'
import { ICard } from 'bot-flow-maker/src/types'
import { ACTION_FORM, ACTION_GOAL, ACTION_MESSAGES, ACTION_QUESTION } from '@/store/actions'

export const ObjectUtils = {
  // eslint-disable-next-line
  mergeObjectLeft: (obj1: Record<string, any>, obj2: Record<string, any>) => {
    for (const key of Object.keys(obj1)) {
      obj1[key] = obj2[key] ?? obj1[key]
    }

    return obj1
  },

  differenceProperties: <T>(object, base) => {
    return transform(object, (result: T, value, key) => {
      if (!isEqual(value, base[key])) {
        // console.log('Difference detected at path:', value)
        result[key] =
          isObject(value) && isObject(base[key]) ? ObjectUtils.differenceProperties(value, base[key]) : value
      }
    })
  },
  isDifference: (object, base) => {
    return !!Object.keys(ObjectUtils.differenceProperties(object, base)).length
  },
  getAnswers: (data: IAnswer) => {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    let result: any[] = []
    if (data.type === constant.ANSWER_TYPE.TEXT) {
      result = data.text_answers ?? []
    } else if (data.type === constant.ANSWER_TYPE.IMAGE) {
      result = data.image_answers ?? []
    } else if (data.type === constant.ANSWER_TYPE.BUTTON) {
      if (data.button_answer?.is_carousel) {
        const carousel_images = data.button_answer?.carousel_images ?? []
        result = []
        for (let index = 0; index < carousel_images.length; index++) {
          const element = carousel_images[index]
          if (element.actions) {
            const ac = element.actions.filter((p) => p.content !== undefined && p.content !== '')
            result = result.concat(ac)
          }
        }
      } else {
        const actions = data.button_answer?.actions ?? []
        result = []
        if (actions) {
          result = actions.filter((p) => p.content !== undefined && p.content !== '')
        }
      }
    } else if (data.type === constant.ANSWER_TYPE.IMAGEMAP) {
      result = data.imagemap_answer?.tappable_area ?? []
    } else if (data.type === constant.ANSWER_TYPE.FLEX) {
      result = ObjectUtils.recurseAction(data.flex_answer?.contents, true)
    } else {
      result = []
    }
    return result
  },
  recurseAction: (component: any, isOnlyPostback: boolean) => {
    let actions: any[] = []
    if (component && typeof component === 'object') {
      if (!Array.isArray(component)) {
        // It's a dictionary/object
        if ('action' in component) {
          const action = component.action
          if (isOnlyPostback) {
            if (action?.type === 'postback') {
              actions.push(action)
            }
          } else {
            actions.push(action)
          }
        }

        for (const key in component) {
          actions = actions.concat(ObjectUtils.recurseAction(component[key], isOnlyPostback))
        }
      } else {
        // It's a list/array
        for (const item of component) {
          actions = actions.concat(ObjectUtils.recurseAction(item, isOnlyPostback))
        }
      }
    }

    return actions
  },

  /* eslint-disable @typescript-eslint/no-explicit-any */
  copyScenario: async (store: any, detail: IInitialCampaignDetail | IPushCampaignDetail) => {
    const { dispatch } = store
    let scenarios = detail.scenarios
    if (scenarios) {
      for (const s of scenarios) {
        if (s.cardType !== 'start') {
          if (s.uniqueId !== 'welcome') {
            // eslint-disable-next-line dot-notation
            s['old_uniqueId'] = cloneDeep(s.uniqueId)
            s.uniqueId = randomString()
          }

          let resource: IMessage | IQuestion | IGoal | IForm = {}
          let action = ''
          if (s.cardType === 'message') {
            action = ACTION_MESSAGES.CLONE
          } else if (s.cardType === 'question') {
            action = ACTION_QUESTION.CLONE
          } else if (s.cardType === 'goal') {
            action = ACTION_GOAL.CLONE
          } else if (s.cardType === 'form') {
            action = ACTION_FORM.CLONE
          }
          let id = ''
          if (s.id && s.id !== '') {
            id = cloneDeep(s.id)
          }
          s.id = ''
          if (action !== '' && id !== '') {
            resource = await dispatch(action, id)

            if (resource && resource._id !== '') {
              s.id = resource._id ?? ''
              s.displayId = resource.display_id ?? ''
              s.title = resource.title ?? ''
            }
          }

          console.log(s.displayId, 'card')
        }
      }

      scenarios = ObjectUtils.updateUniqueIdNextCard(scenarios)
    }

    detail.scenarios = scenarios
    return detail
  },

  updateUniqueIdNextCard: (scenarios: ICard[]) => {
    for (const scenario of scenarios) {
      for (const answer of scenario.answers) {
        for (const nextCard of answer.nextCards) {
          const uniqueId = ObjectUtils.getUniqueIdNextCard(scenarios, nextCard.uniqueId)
          if (uniqueId) {
            // eslint-disable-next-line dot-notation
            nextCard['old_uniqueId'] = cloneDeep(nextCard.uniqueId)
            nextCard.uniqueId = uniqueId
          }
        }
      }
    }
    return scenarios
  },
  getUniqueIdNextCard: (scenarios: ICard[], uniqueId) => {
    for (const scenario of scenarios) {
      // eslint-disable-next-line dot-notation
      if (scenario['old_uniqueId'] === uniqueId) {
        return scenario.uniqueId
      }
    }
    return null
  },
}
